/*=========================================================================================
  File Name: moduleDashboardActions.js
  Description: Dashboard Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    fetchDownloadCount({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/dashboard/counts')
                .then((response) => {
                    commit('SET_DOWNLOAD_COUNT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchWowzaDailyReport({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/dashboard/daily-report')
                .then((response) => {
                    commit('SET_DAILY_WOWZA_REPORT', response.data.resultBody)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}